import React from 'react';
import LandingPage from './components/LandingPage/LandingPage';
import Login from './components/Login/Login';
import Blog from './components/Blog/Blog';
import BlogPost from './components/BlogPost/BlogPost';
import Dashboard from './components/Dashboard/Dashboard';
import Teams from './components/Teams/Teams';
import CreateTeam from './components/CreateTeam/CreateTeam';
import Notifications from './components/Notifications/Notifications';
import Statistics from './components/Statistics/Statistics';
import UserSettings from './components/UserSettings/UserSettings';
import AboutUs from './components/AboutUs/AboutUs';
import Contact from './components/Contact/Contact';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './components/TermsOfService/TermsOfService';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import useAuth from './hooks/useAuth';

function App() {
  const { user, currentTeam, setUser, setCurrentTeam } = useAuth();

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="App">
        {user ? (
          <Routes>
            <Route path="/" element={<Dashboard user={user} setUser={setUser} currentTeam={currentTeam} />} />
            <Route path="/teams" element={<Teams user={user} />} />
            <Route path="/create-team" element={<CreateTeam user={user} currentTeam={currentTeam} setCurrentTeam={setCurrentTeam} />} />
            <Route path="/notifications" element={<Notifications user={user} />} />
            <Route path="/statistics" element={<Statistics user={user} teamId={currentTeam ? currentTeam.id : null} />} />
            <Route path="/settings" element={<UserSettings user={user} setUser={setUser} />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:postId" element={<BlogPost />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            {/* Redirect login or unknown paths to dashboard when authenticated */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          <>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:postId" element={<BlogPost />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="*" element={<LandingPage />} />
            </Routes>
          </>
        )}
      </div>
    </Router>
  );
}

export default App;